import {generateRoutePath} from '@epic-core/common';

export const isComingSoon = productOffer => {
    const effectiveDate = productOffer && productOffer.get('effectiveDate');
    return !!effectiveDate && new Date(effectiveDate) > new Date();
};

export const getProductRouteUri = (base, productName, productSlug) => {
    // add leading slash
    let uri = base.charAt(0) !== '/' ? `/${base}` : base;
    // remove trailing slash
    uri = uri.replace(/\/$/, '');

    if (productName) {
        uri += `/${productName}`;

        if (productSlug) {
            uri += `/${productSlug}`;
        }
    }
    return uri;
};

export const generateProductRoutePath = (base, productName, productSlug) =>
    generateRoutePath(getProductRouteUri(base, productName, productSlug));

export const isRegionBlocked = (pageData, ipCountryCode, accountCountryCode) => {
    if (!pageData || !pageData.regionBlock) return false;
    const regionBlacklist = pageData.regionBlock.split(',');
    if (ipCountryCode && regionBlacklist.includes(ipCountryCode)) return true;
    if (accountCountryCode && regionBlacklist.includes(accountCountryCode)) return true;
    return false;
};

export const ratingsFromLegalTags = (legalTags, country) => {
    return legalTags
        .filter(x => {
            if (x.get('visibility') === 'visibleToAll') {
                return true;
            }

            const countryCodes = x.get('countryCodes');
            if (!countryCodes) {
                return false;
            }

            return countryCodes.includes(country);
        })
        .map(x => ({altText: '', src: x.get('src')}));
};

export default {
    isComingSoon,
    isRegionBlocked,
    generateProductRoutePath
};
